import deviceInfo from './deviceInfo';

export const isFirefoxBrowser = /firefox/i.test(navigator.userAgent.toLocaleLowerCase());
export const isIosUnder13Version = (
  deviceInfo && deviceInfo?.os?.name.toLocaleLowerCase() === 'ios' && Number(deviceInfo?.os?.version) < 13
);
